<template>
    <div class="generator_popup_container" @click.self="closePopup">
    <!-- <div class="popup_overlay"> -->
        <div class="generator_popup">
            <div class="bkrdSymGenerator no_border">
                <h4 class="popup_title">
                    Generate {{ selectedBarcode.title }} barcode
                    <button class="close" @click="closePopup"><svg viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg></button>
                </h4>
                <div class="gen_block">
                    <h4 class="gen_block_title">Content</h4>
                    <div class="resRow">
                        <div class="resBox">
                            <div class="generator_line for_validation">
                                <h4 for="barcode_value">Barcode Content</h4>
                                <div>
                                    <textarea id="barcode_value" name="barcode_value" v-model="v$.form.barcode_value.$model" :class="{ textarea_input: true, 'not-valid': v$.form.barcode_value.$errors.length }" placeholder="Barcode value"></textarea>
                                    <div class="form-message" v-for="(error, index) of v$.form.barcode_value.$errors" :key="index">
                                        <div>{{ error.$message  }}</div>
                                    </div>
                                    <p class="sm_msg">
                                        Example: {{ selectedBarcode.example }}
                                    </p>
                                </div>
                                <div v-if="contentError" class="content_error">{{ contentError }}</div>
                            </div>
                            <div class="generator_line generator_captcha" :class="{ invalid: v$.form.recaptcha_token.$error, verified: form.recaptcha_token }">
                                <RecaptchaV2
                                    class="captcha"
                                    :tabindex="0"
                                    @widget-id="handleWidgetId"
                                    @error-callback="handleErrorCalback"
                                    @expired-callback="handleExpiredCallback"
                                    @load-callback="handleLoadCallback"
                                />
                                <div v-if="form.recaptcha_token" class="captcha_verified">
                                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8.143 13.314 4.83 10l-1.13 1.123 4.443 4.443 9.314-9.314L16.33 5.12z"></path></svg>
                                    <span>reCAPTCHA verified</span>
                                </div>
                                <div v-if="v$.form.recaptcha_token.$error" class="q-error-badge">Please check the reCAPTCHA box</div>
                            </div>
                            <div class="generator_line">
                                <button @click.prevent="submit(false)" class="button link outline" :disabled="submitting">
                                    <template v-if="submitting">
                                        Generating...
                                    </template>
                                    <template v-else>
                                        Generate<svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('arrow_right')"></use></svg>
                                    </template>
                                </button>
                            </div>
                        </div>

                        <div v-if="selectedBarcode.data_sym_type" class="resBox info_line_wrap">
                            <div v-if="selectedBarcode.char_set" class="info_line">
                                <div class="info">
                                    <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('info')"></use></svg>
                                </div>
                                <div class="txt">
                                    <h4>Character Set:</h4>
                                    <div class="info_desc">
                                        <div class="charset">{{selectedBarcode.char_set}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedBarcode.length" class="info_line">
                                <div class="info">
                                    <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('info')"></use></svg>
                                </div>
                                <div class="txt">
                                    <h4>Length:</h4>
                                    <div class="info_desc">
                                        <div class="length">{{selectedBarcode.length}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedBarcode.category" class="info_line">
                                <div class="info">
                                    <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('info')"></use></svg>
                                </div>
                                <div class="txt">
                                    <h4>Category:</h4>
                                    <div class="info_desc">
                                        <div class="category">{{selectedBarcode.category}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gen_block">
                    <h4 class="gen_block_title">Output</h4>
                    <div class="resRow">
                        <div class="resBox">
                            <div class="radioBtns">
                                <h4>Format:</h4>
                                <div class="form_radio_btn format">
                                    <label :class="{ radio_selected: form.format == 'PNG' }">
                                        <svg viewBox="0 0 48 48"><path d="M4 21.8125H8.47917V26.1875H4V21.8125ZM21.8125 8.47917H26.1875V17.3333H21.8125V8.47917ZM17.3333 21.8125H26.1875V30.6667H21.8125V26.1875H17.3333V21.8125ZM30.6667 21.8125H35.1458V26.1875H39.5208V21.8125H44V26.1875H39.5208V30.6667H44V39.5208H39.5208V44H35.1458V39.5208H26.1875V44H21.8125V35.1458H30.6667V30.6667H35.1458V26.1875H30.6667V21.8125ZM39.5208 39.5208V30.6667H35.1458V39.5208H39.5208ZM30.6667 4H44V17.3333H30.6667V4ZM35.1458 8.47917V12.8542H39.5208V8.47917H35.1458ZM4 4H17.3333V17.3333H4V4ZM8.47917 8.47917V12.8542H12.8542V8.47917H8.47917ZM4 30.6667H17.3333V44H4V30.6667ZM8.47917 35.1458V39.5208H12.8542V35.1458H8.47917Z" fill="var(--fill-color)"></path></svg>
                                        PNG
                                        <input v-model="form.format" type="radio" name="format" value="PNG" checked="checked" />
                                    </label>
                                    <label :class="{ radio_selected: form.format == 'SVG' }">
                                        <svg viewBox="0 0 48 48"><path d="M35.4286 4C36.2024 4 36.8571 4.26786 37.3929 4.80357C37.9286 5.33929 38.1964 6.02381 38.1964 6.85714C38.1964 7.63095 37.9286 8.28571 37.3929 8.82143C36.8571 9.35714 36.2024 9.65476 35.4286 9.71429C34.9524 9.71429 34.5357 9.59524 34.1786 9.35714L27.125 16.4107L27.75 17.3036C29.8929 16.1131 32.1548 15.1905 34.5357 14.5357C36.9167 13.8214 39.4167 13.4643 42.0357 13.4643L44 13.5536V17.3929L42.0357 17.3036C39.5952 17.3036 37.244 17.6607 34.9821 18.375C32.7202 19.0298 30.6369 19.9821 28.7321 21.2321C28.6726 23.3155 27.9286 25.0714 26.5 26.5C25.0714 27.9286 23.3155 28.6726 21.2321 28.7321C19.9821 30.6369 19 32.7202 18.2857 34.9821C17.631 37.244 17.3036 39.5952 17.3036 42.0357L17.3929 44H13.5536L13.4643 42.0357C13.4643 39.4167 13.7917 36.9167 14.4464 34.5357C15.1607 32.1548 16.1131 29.8929 17.3036 27.75L16.4107 27.125L9.35714 34.1786C9.59524 34.5357 9.71429 34.9524 9.71429 35.4286C9.65476 36.2024 9.35714 36.8571 8.82143 37.3929C8.28571 37.9286 7.60119 38.1964 6.76786 38.1964C5.99405 38.1964 5.33929 37.9286 4.80357 37.3929C4.26786 36.8571 4 36.2024 4 35.4286C4 34.5952 4.26786 33.9107 4.80357 33.375C5.33929 32.8393 6.02381 32.5714 6.85714 32.5714C7.27381 32.5714 7.69048 32.6607 8.10714 32.8393L15.0714 25.7857C14.0595 24.4762 13.5238 22.9286 13.4643 21.1429C13.5238 18.9405 14.2679 17.125 15.6964 15.6964C17.125 14.2679 18.9405 13.5238 21.1429 13.4643C22.9286 13.5238 24.4762 14.0595 25.7857 15.0714L32.8393 8.10714C32.6607 7.69048 32.5714 7.27381 32.5714 6.85714C32.5714 6.02381 32.8393 5.33929 33.375 4.80357C33.9107 4.26786 34.5952 4 35.4286 4ZM21.1429 17.3036C20.0714 17.3036 19.1488 17.6905 18.375 18.4643C17.6607 19.1786 17.3036 20.0714 17.3036 21.1429C17.3036 22.2143 17.6607 23.1071 18.375 23.8214C19.1488 24.5357 20.0714 24.8929 21.1429 24.8929C22.2143 24.8929 23.1071 24.5357 23.8214 23.8214C24.5357 23.1071 24.8929 22.2143 24.8929 21.1429C24.8929 20.0714 24.5357 19.1786 23.8214 18.4643C23.1071 17.6905 22.2143 17.3036 21.1429 17.3036Z" fill="var(--fill-color)"></path></svg>
                                        SVG
                                        <input v-model="form.format" type="radio" name="format" value="SVG" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="resBox">
                            <div class="radioBtns">
                                <h4>Size:</h4>
                                <div class="form_radio_btn resolution">
                                    <label :class="{ radio_selected: form.resulution == 'small' }">
                                        Small
                                        <span v-if="sizePixels.small" class="size_px">{{ sizePixels.small }} px</span>
                                        <input v-model="form.resulution" type="radio" name="resulution" value="small" />
                                    </label>
                                    <label :class="{ radio_selected: form.resulution == 'medium' }">
                                        Medium
                                        <span v-if="sizePixels.medium" class="size_px">{{ sizePixels.medium }} px</span>
                                        <input v-model="form.resulution" type="radio" name="resulution" value="medium" />
                                    </label>
                                    <label :class="{ radio_selected: form.resulution == 'large' }">
                                        Large
                                        <span v-if="sizePixels.large" class="size_px">{{ sizePixels.large }} px</span>
                                        <input v-model="form.resulution" type="radio" name="resulution" value="large" />
                                    </label>
                                </div>
                            </div>
                            <div class="generator_line">
                                <button @click.prevent="download" class="button link outline" :disabled="!generatedBarcodeUrl">
                                    <svg viewBox="0 0 25 25"><use :xlink:href="spriteHref('cloud-download')"></use></svg>
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gen_block">
                    <h4 class="gen_block_title">Barcode</h4>
                    <div class="resultImageWrapper">
                        <img v-if="generatedBarcodeUrl" :src="generatedBarcodeUrl" alt="barcode" @load="onBarcodeLoad" />
                        <img v-else :src="img_path + selectedBarcode.img" class="default" alt="barcode" />
                    </div>
                    <p v-if="barcodeSize.width" class="barcode_size">{{ barcodeSize.width }} &times; {{ barcodeSize.height }} px</p>
                </div>
            </div>
        </div>
    <!-- </div> -->
    </div>
</template>

<script>
import { ref } from "vue";
import { WEB_USERNAME, WEB_PASS, ENV, HOME_URL } from "../constants/envrionment";
import { RecaptchaV2, useRecaptcha } from "vue3-recaptcha-v2";
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import defaultBarcodeImage from "../assets/img/barcode.png"

// Content rules keyed by the zint symbology id the popup sends. Each pattern
// was verified against the installed zint, so it rejects exactly the input
// that cannot be generated for that symbology.
const BARCODE_CONTENT_RULES = {
    '18': { pattern: /^[A-Da-d][0-9$:/.+-]*[A-Da-d]$/, message: 'Codabar must start and end with A, B, C or D, with only digits and - $ : / . + in between.' },
    '1': { pattern: /^[0-9-]+$/, message: 'Code 11 accepts only digits and dashes.' },
    '7': { pattern: /^[0-9]{1,45}$/, message: 'Code 25 accepts digits only, up to 45 digits.' },
    '129': { pattern: /^[0-9]{1,8}$/, message: 'Code 32 accepts digits only, up to 8 digits.' },
    '8': { pattern: /^[0-9A-Za-z +\-$%./]+$/, message: 'Code 39 accepts digits, letters, space and - + $ % . / only.' },
    '25': { pattern: /^[0-9A-Za-z +\-$%./]+$/, message: 'Code 93 accepts digits, letters, space and - + $ % . / only.' },
    '20': { pattern: /^[\x20-\x7E]+$/, message: 'Code 128 accepts standard printable characters only.' },
    '34': { pattern: /^[0-9]{1,13}$/, message: 'This barcode accepts digits only, up to 13 digits.' },
    '13': { pattern: /^(?:[0-9]{2}|[0-9]{5}|[0-9]{7,8}|[0-9]{12,13})$/, message: 'EAN accepts 2, 5, 7, 8, 12 or 13 digits only.' },
    '35': { pattern: /^[0-9]{1,14}\|[0-9A-Za-z +\-$%./]+$/, message: 'Use the format PRIMARY|COMPOSITE, e.g. 12345678901234|barKoder.' },
    '47': { pattern: /^[0-9]+$/, message: 'MSI Plessey accepts digits only.' },
    '90': { pattern: /^[0-9A-Za-z]+$/, message: 'This barcode accepts letters and digits only.' },
    '87': { pattern: /^[0-9Xx]{1,60}$/, message: 'Telepen accepts digits and the letter X only, up to 60 characters.' },
    '92': { pattern: /^[\x20-\x7E]+$/, message: 'Aztec accepts standard printable characters only.' },
    '71': { pattern: /^[\x20-\x7E]+$/, message: 'Data Matrix accepts standard printable characters only.' },
    '115': { pattern: /^[\x20-\x7E]+$/, message: 'DotCode accepts standard printable characters only.' },
    '57': { pattern: /^[\x20-\x7E]+$/, message: 'MaxiCode accepts standard printable characters only.' },
    '55': { pattern: /^[\x20-\x7E]+$/, message: 'PDF417 accepts standard printable characters only.' },
    '58': { pattern: /^[\x20-\x7E]+$/, message: 'QR Code accepts standard printable characters only.' },
};

export default {
    props: ['selectedBarcode'],
    components: {
        RecaptchaV2,
    },
    data() {
        return {
            form: {
                recaptcha_token: "",
                barcode_type: "",
                format: "PNG",
                resulution: "large",
                barcode_value: "",
            },
            home_url: HOME_URL,
            generatedBarcodeUrl: '',
            downloadGrant: '',
            barcodeSize: { width: 0, height: 0 },
            img_path: HOME_URL + "themes/barkoder/img/",
            submitting: false,
        };
    },
    setup() {
        return {
            v$: useVuelidate(),
            recaptcha: useRecaptcha(),
            recaptcha_widget_id: ref(null),
        };
    },
    validations() {

        const validCharSet = (value) => {
            const rule = this.contentRule;

            if (!rule || !helpers.req(value)) {
                return true;
            }

            return rule.pattern.test(value);
        }

        return {
            form: {
                barcode_value: {
                    required: helpers.withMessage('Please enter value', required),
                    validCharSet: helpers.withMessage(() => this.contentError || 'This content cannot be generated with the selected barcode type', validCharSet),
                },
                recaptcha_token: {
                    required: helpers.withMessage("You must prove that you are not a robot - check the reCAPTCHA box.", required),
                },
            },
        }
    },
    watch: {
        'form.barcode_value': function (newVal, oldVal) {
            if (!newVal) {
                this.generatedBarcodeUrl = ''
            }
        },
    },
    computed: {
        // Per-symbology rule, verified against the installed zint so the live
        // check rejects exactly the content that cannot be generated.
        contentRule() {
            const type = String(this.selectedBarcode.data_sym_type || '');
            return BARCODE_CONTENT_RULES[type] || null;
        },
        contentError() {
            const value = this.form.barcode_value;
            const rule = this.contentRule;

            if (!rule || !value) {
                return '';
            }

            return rule.pattern.test(value) ? '' : rule.message;
        },
        // Pixel width each size option produces, scaled from the measured
        // barcode. zint's --scale is 2 / 5 / 10 for small / medium / large.
        sizePixels() {
            const scales = { small: 2, medium: 5, large: 10 };
            const base = this.barcodeSize.width / (scales[this.form.resulution] || 10);

            if (!base) {
                return { small: '', medium: '', large: '' };
            }

            return {
                small: Math.round(base * scales.small),
                medium: Math.round(base * scales.medium),
                large: Math.round(base * scales.large),
            };
        },
        barcodeDefaultBarcodeImage: function () {

            return defaultBarcodeImage
        },
        barcode_type_options: function () {

            let res = {};

            for (const [i, o] of Object.entries(this.symbologies_info)) {
                for (const [k, s] of Object.entries(o)) {
                    res[k] = s.name
                }
            }

            return res;
        },
        barcode_text_type_options: function () {

            let res = {};

            for (const [i, o] of Object.entries(this.symbologies_info)) {
                for (const [k, s] of Object.entries(o)) {
                    res[s.name] = {
                        'type': i,
                        'sym': k
                    }
                }
            }
            return res;
        },
    },
    methods: {
        closePopup() {
            this.$emit('closePopup');
        },
        onBarcodeLoad(event) {
            const image = event.target;

            this.barcodeSize = {
                width: image.naturalWidth,
                height: image.naturalHeight,
            };
        },
        resetRecaptcha() {
            this.form.recaptcha_token = "";

            if (this.recaptcha_widget_id !== null) {
                this.recaptcha.handleReset(this.recaptcha_widget_id);
            }
        },
        submitFailed(message) {
            this.submitting = false;
            this.resetRecaptcha();
            window.barKoder.notify("error", message);
        },
        handleWidgetId(widgetId) {
            this.recaptcha_widget_id = widgetId;
        },
        handleErrorCalback() {
            this.form.recaptcha_token = "";
        },
        handleExpiredCallback() {
            this.form.recaptcha_token = "";
        },
        handleLoadCallback(response) {
            this.form.recaptcha_token = response;
        },

        download() {
            if (!this.generatedBarcodeUrl) {
                return
            }
            this.submit(true)
        },
        async submit(download) {

            let self = this,
                downloadImage = (typeof download != 'undefined' && download);

            // The initial generate requires a solved reCAPTCHA. A download
            // re-uses the already generated (and verified) barcode, so it is
            // authorised by the signed grant instead and skips validation.
            if (!downloadImage) {
                const result = await this.v$.$validate()
                if (!result) {
                    return
                }
                this.submitting = true;
            }

            let post_params = {
                recaptcha_token: self.form.recaptcha_token,
                barcode_type: self.form.barcode_type,
                format: self.form.format,
                resulution: self.form.resulution,
                barcode_value: self.form.barcode_value,
            }

            if (downloadImage) {
                post_params['download'] = true;
                post_params['download_grant'] = self.downloadGrant;
            }
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(post_params)
            };
            if (ENV == 'dev') {
                requestOptions['headers']['authorization'] = "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
            }

            fetch(this.home_url + 'barcodeGenerators/generate_barcode', requestOptions)
                .then(async response => {
                    let data = null;

                    try {
                        data = await response.json();
                    } catch (e) {
                        data = null;
                    }

                    self.submitting = false;

                    if (data && data.status) {
                        if (downloadImage) {
                            window.location.href = self.home_url + 'barcodeGenerators/download_barcode/' + data.file_name;
                        }
                        else {
                            // Keep the solved reCAPTCHA hidden; it is shown
                            // again only when it expires (handleExpiredCallback)
                            // or a request fails (submitFailed -> resetRecaptcha).
                            self.generatedBarcodeUrl = data.file_url;
                            self.downloadGrant = data.download_grant || '';
                        }
                        return;
                    }

                    if (downloadImage) {
                        self.submitting = false;
                        window.barKoder.notify("error", data && data.message ? data.message : "Download failed. Please generate the barcode again.");
                        return;
                    }

                    self.submitFailed(data && data.message ? data.message : "Something went wrong. Please try again.");
                })
                .catch(() => {
                    if (downloadImage) {
                        self.submitting = false;
                        window.barKoder.notify("error", "We couldn't reach the server. Please check your connection and try again.");
                        return;
                    }
                    self.submitFailed("We couldn't reach the server. Please check your connection and try again.");
                });
        },
        isObject: function (value) {
            return value && typeof value === 'object' && value.constructor === Object;
        },
        objectLength: function (obj) {
            return (this.isObject(obj)) ? Object.keys(obj).length : 0;
        }
    },
    mounted: function () {

        let self = this;

        if (this.objectLength(this.selectedBarcode)) {
            this.form.barcode_type = this.selectedBarcode.data_sym_type
            this.form.barcode_value = this.selectedBarcode.example
        }

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                self.closePopup()
            }
        })


    },
};
</script>